"use strict";

exports.__esModule = true;
exports.HandsontableCellType = exports.CELL_TYPE = void 0;
var _handsontableType = require("./handsontableType");
exports.CELL_TYPE = _handsontableType.CELL_TYPE;
exports.HandsontableCellType = _handsontableType.HandsontableCellType;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/cellTypes/handsontableType/index.js
// module id = 1104
// module chunks = 0